export const rustWebAppDevelopmentPageSeo = {
  title:
    'Rust Web Development Services | High-Performance Apps with Rumble Fish',
  meta: [
    {
      name: 'keywords',
      content:
        'rust web development services, rust web application development, rust api development, webassembly development services, rust microservices development, rust backend development, high-performance web applications, rust web framework development, rust web development company, hire rust developers, rust actix web development, rust axum framework development, rust wasm development services, rust api optimization services',
    },
    {
      name: 'description',
      content:
        'Build lightning-fast web applications with Rust. Expert development services for high-performance APIs, WebAssembly apps, and scalable systems. 3-10x faster than Node.js.',
    },
  ],
};
